import Vue from 'vue'

// debug
global.D = false

var domain = window.location.host
//生产配置
if (domain == 'rs.daspatial.com') {
}
// 开发配置
else {
  // 任务/调度/登陆/应用
  // global.HOST = "https://sapi.daspatial.com/"
  global.HOST = 'https://sapi.daspatial.com'
  // global.HOST = 'http://10.100.202.221:9999'
  // global.HOST = 'http://10.100.6.222:9999/'
  // global.HOST = "https://testapi.daspatial.com/";
  // global.SIGN_HOST = "http://10.0.1.198:8888/"
  // global.REDIRECT_HOST = "http://10.0.1.234:8080/"
  // global.AUTHORIZATION = "dGVzdDp0ZXN0"
  // global.CLIENT_ID = "test"
  global.DETAILHOST = 'https://www.daspatial.com/'

  // global.DETAILHOST = "http://10.0.1.225:7444/"
  global.OSSIMG =
    '?x-oss-process=image/resize,w_280,h_280,m_mfit/auto-orient,1/quality,q_100/sharpen,1/format,jpg'
}

global.apis = {
  isLogin: function() {
    if (localStorage.getItem('session') === null) {
      return false
    }
    let sessionInfo = JSON.parse(localStorage.getItem('session'))
    if (sessionInfo.isLogin === null) {
      return false
    }
    return sessionInfo.isLogin
  },
  doLogout: function() {
    localStorage.removeItem('session')
  },
  getToken: function() {
    if (localStorage.getItem('session') === null) {
      return false
    }
    let sessionInfo = JSON.parse(localStorage.getItem('session'))
    if (sessionInfo.token === null) {
      return false
    }
    return sessionInfo.token
  },
  setToken: function(access_token) {
    localStorage.setItem(
      'session',
      JSON.stringify({ isLogin: true, token: access_token })
    )
  },
  setBind: function(param) {
    localStorage.setItem('bind', JSON.stringify(param))
  },
  getBind: function() {
    return JSON.parse(localStorage.getItem('bind'))
  },
  removeBind: function() {
    localStorage.removeItem('bind')
  },
  setOrigin: function(origin) {
    localStorage.setItem('origin', origin)
  },
  getOrigin: function() {
    return localStorage.getItem('origin')
  },
  removeOrigin: function() {
    localStorage.removeItem('origin')
  },
  setState: function(state) {
    localStorage.setItem('state', state)
  },
  getState: function() {
    return localStorage.getItem('state')
  },
  setLanguage: function(language) {
    localStorage.setItem('language', language)
  },
  getLanguage: function() {
    let language = localStorage.getItem('language')

    if (language == null) {
      return 'Ch'
    } else return language
  },
  setAutoRebuild: function(param) {
    localStorage.setItem('autorebuild', param)
  },
  getAutoRebuild: function() {
    return localStorage.getItem('autorebuild')
  },
  setNoMoreTip: function(nomoertip) {
    localStorage.setItem('nomoertip', nomoertip)
  },
  getNoMoreTip: function() {
    return localStorage.getItem('nomoertip')
  }
}

global.tools = {
  decodeHtml: function(html) {
    var txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  },
  userAgent: window.navigator.userAgent,
  isDesktop: function() {
    let md = new detect(window.navigator.userAgent)
    return md.mobile() == null ? true : false
  },
  webglSupport: function() {
    try {
      var canvas = document.createElement('canvas')
      return !!(
        window.WebGLRenderingContext &&
        (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
      )
    } catch (e) {
      return false
    }
  },
  // 三维坐标转二维坐标
  vecToScreen: function(x, y, z, camera, width, height, offsetX, offsetY) {
    if (!offsetX) offsetX = 0
    if (!offsetY) offsetY = 0
    var p = new THREE.Vector3(x, y, z)
    var vector = p.project(camera)

    vector.x = ((vector.x + 1) / 2) * width
    vector.y = (-(vector.y - 1) / 2) * height
    vector.x += offsetX
    vector.y += offsetY
    return { x: vector.x, y: vector.y }
  },
  // canvas截取图像流
  canvasToImage: function(canvas) {
    var image = new Image()
    image.src = canvas.toDataURL('image/jpeg', 1)
    return image
  },
  screenToVec: function(x, y, camera, width, height) {
    var vector = new THREE.Vector3()

    vector.set((x / width) * 2 - 1, -(y / height) * 2 + 1, -0.5)

    vector.unproject(camera)

    var dir = vector.sub(camera.position).normalize()

    var distance = -camera.position.z / dir.z

    return camera.position.clone().add(dir.multiplyScalar(distance))
  }
}



// WEBPACK FOOTER //
// ./src/utils/global.js